//in this object are all the keys that are part of the texts that are shown in all the pages
import React from "react";
//TodoSomeone: Check repeated keys

export default {
  responseStory:"Responder historia",
  deleteStory:"Borrar historia",
  archiveStory:"Archivar historia",
  unArchiveStory:"Desarchivar historia",
  modAdd: "Añadir moderador",
  modRemove: "Eliminar moderador",
  PRRS: "PQRS",
  PQRS: "PQRS",
  login: "Iniciar sesión",
  loginUser: "Dirección de correo electrónico",
  loginPassword: "Contraseña",
  loginNextButton: "Siguiente",
  loginWithAnotherWay: "También puedes ingresar con:",
  textWelcomeLogin: "Hola",
  askForAccountLogin: "¿No eres Usuario? ",
  creatYourAccount: "Crea tu cuenta",
  forgetPasswordQuestion: "¿Olvidaste tu contraseña?",
  forgetPasswordMsg: "Recuperar contraseña",
  recoverPassword: "Recuperar",
  registerEmail: "Registra tu correo",
  isAcceptTerms: "No has aceptado los terminos del servicio",
  birthDate: "Fecha de nacimiento",
  buttonRegister: "Registrarse",
  registerText: "Registrar",
  receptionRecords: "Historial de recepciones",
  share: "Compartir",
  messageAcceptTerms: "He leído y aceptado los términos y condiciones",
  invalidEmail: "Correo invalido, debe contener @ y .",
  passwordNoMatch: "Las contraseñas no coinciden",
  passwordToLong: "La contraseña debe tener máximo 32 caracteres",
  passwordToShort: "La contraseña debe tener al menos 6 caracteres",
  confirmPassword: "Confirma contraseña",
  password: "Contraseña",
  email: "Correo",
  name: "Nombre",
  lastName: "Apellido",
  referralCode: "Código de referido",
  messageCreateAccount: "Crea tu cuenta",
  missingField: "Este campo es obligatorio",
  textInformation: "Información",
  following: "Siguiendo",
  followers: "Seguidores",
  followed: "Seguidos",
  friends: "EcoAmigos",
  liked: "Me gusta",
  myPost: "Mi perfil",
  myFavorites: "Favoritos",
  mySaved: "Guardados",
  myPrivate: "Privado",
  myRanking: "Ranking",
  photos_video: "Foto/Video",
  audio: "Audio",
  videos: "Videos",
  stories: "Historias",
  messageRecoverPassword: "Recuperar contraseña",
  enterEmail: "Ingresa tu correo",
  send: "Enviar",
  verificationCode: "Código de verificación",
  sendCodeVerification: "Hemos enviado un código de verificación a tu correo",
  cancel: "Cancelar",
  accept: "Aceptar",
  resend: "Reenviar",
  delete: "Eliminar",
  loginWithAnotherAccount: "Iniciar sesión con otra cuenta",
  deleteAccount: "ELIMINAR CUENTA",
  headerCodeVerification: "Código de verificación",
  deletePassword: "Eliminar contraseña",
  deleteAccountOption: "Eliminar cuenta del dispositivo",
  silentNotifications: "Silenciar notificaciones",
  contentDeleteAccountOption:
    "Deberías ingresar tu teléfono o correo electrónico la próxima vez que inicies sesión",
  headerDeleteAccountOption: "¿Eliminar la cuenta de este dispositivo?",
  createStory: "Crea tu historia",
  trends: "Tendencias",
  classified: "Clasificados",
  ranking: "Ranking",
  invalidRegister: "Registro invalido",
  deleteFriend: "Eliminar amigo",
  blockFriend: "Bloquear",
  ERR001: "Contraseña incorrecta",
  ERR002: "El usuario no existe",
  ERR003: "Error al traer los registros",
  ERR004: "Error al guardar el registro",
  ERR005: "El usuario ya existe",
  ERR006: "No existe un código de verificación",
  ERR007: "El correo es necesario",
  ERR008: "El correo es inválido",
  ERR009: "El correo no esta verificado",
  ERR010: "Problema al eliminar usuario",
  ERR011:
    "Se excedió el número máximo de envíos de código de verificación, intenta más tarde",
  ERR012: "Se debe esperar un momento antes de volver a enviar el código.",
  ERR013: "No se ha podido enviar el email",
  ERR014:
    "No es posible restablecer la contraseña, el usuario tiene problemas de verificación",
  ERR015: "Código incorrecto, se excedió el número máximo de intentos",
  ERR016: "El código ha expirado",
  ERR017: "Código incorrecto",
  ERR018: "El correo es necesario",
  ERR019: "Error en el servidor",
  ERR020: "Es necesario repetir el proceso de registro",
  ERR021: "El registro no existe",
  ERRXXX: "ya existe el usuario",
  ERR034: "Ya existe otro perfil con este correo",
  ERR049:
    "Ya existe una marca registrada con este correo, inicia sesión con contraseña",
  tittleModalNewPost: "Comparte lo que haces",
  writes: "Escribe...",
  addNewPostContent: "Agrega",
  tagFriend: "Etiquetar amigo",
  tagto: "Etiquetar a",
  privacity: "Privacidad",
  publish: "Publicar",
  continue: "Continuar",
  ERR022:
    "El formato del archivo no es válido, formatos válidos .png, .jpeg, .gif...",
  ERR023: "Error al subir el archivo",
  ERR024: "Error al actualizar el registro",
  ERR025: "Token incorrecto",
  ERR026: "Cuenta con registro mediante Facebook",
  ERR027: "Cuenta con registro mediante Google",
  ERR028: "Cuenta con registro mediante Facebook y Google",
  ERR044: "Cuenta pendiente por validar mediante Google",
  ERR053: "Ya se ha enviado un código de verificación a su correo",
  ERR058: "Ya existe un usuario registrado con este correo",
  ERR095: "Ya existe el usuario, inicio de sesión con contraseña",
  edit: "Editar",
  uploadAudio: "Publicar audio",
  ERR032: "Ya existe una solcitud pendiente",
  nameMark: "Nombre de la marca",
  birthMark: "Fecha de creación",
  economicActivity: "Actividad económica",
  textMsgChat: "Escribe un mensaje",
  description: "Detalles sobre ti",
  aspiration: "Mi sueño",
  phone: "Teléfono",
  ubication: "Ubicación",
  gender: "Género",
  female: "Femenino",
  male: "Masculino",
  other: "Otro",
  updateUserInfo: "Actualiza tus datos",
  currentPassword: "Contraseña actual",
  newPassword: "Nueva contraseña",
  confirmNewPassword: "Confirma la nueva contraseña",
  isNotANewPassword: "La contraseña nueva no puede ser igual que la actual",
  addComment: "Agrega un comentario",
  workplaces: "Nombre de la empresa",
  studies: "Nombre del título",
  university: "Nombre de la institución",
  alias: "Alias",
  relationshipStatus: "Estado civil",
  originCity: "Ciudad de origen",
  currentCity: "Ciudad donde vives",
  single: "Soltero(a)",
  inARelationship: "En una relación",
  engaged: "Comprometido(a)",
  married: "Casado(a)",
  inACivilUnion: "En una unión civil",
  changeProfilePicture: "Cambiar foto de perfil",
  contacts: "Contactos",
  experience: "Experiencia",
  studiesProfessional: "Estudios",
  certificates: "Certificados",
  skills: "Habilidades",
  requests: "Solicitudes",
  acceptFriendRequest: "Aceptar solicitud de amistad",
  cancelFriendRequest: "Cancelar solicitud de amistad",
  rejectFriendRequest: "Rechazar solicitud de amistad",
  certificateAccount: "Certificar cuenta",
  messageCertificate:
    "Tu solicitud está siendo atendida, recibirás la notificación sobre la autenticación de tu cuenta.",
  uploadPictureToCertificate:
    "Sube una fotografía de tu rostro en este momento, esta imagen no será publicada",
  descriptionMark: "Descripción",
  originCountry: "País de origen",
  currentCountry: "País donde vives",
  typeOfMark: "Tipo de perfil",
  person: "Persona",
  enterprise: "Empresa",
  confirm: "Confirmar",
  titleCurrentStudyProfessional:
    "Puedes activar o desactivar los estudios que quieras.",
  titleCurrentExperienceProfessional:
    "Puedes desactivar las experiencias que quieras.",
  activeDeactive: "Activar",
  records: "Archivos",
  addAlbum: "Crear álbum",
  editAlbum: "Editar álbum",
  privacyMessageTittle: "Escoge quién puede ver tu álbum",
  privacyMessageDescription:
    "puedes escoger si el álbum es público o solo para ti",
  privacyMessageTittleNewPost: "Escoge quién puede ver esta publicación",
  privacyMessageDescriptionNewPost:
    "Escoja la privacidad del post",
  private: "Privado",
  private_f: "Privada",
  public: "Público",
  public_f: "Pública",
  category: "Categoría",
  onlyFriends: "Solo amigos",
  justMe: "Solo para mi",
  uploadConentTo: "Sube contenido a ",
  create: "Crear ",
  block: "Bloquear",
  report: "Reportar",
  saveQR: "Guardar QR",
  rememberCode: "Recuerde. El código lo encuentra en su correo",
  rememberCodeInit: "Se enviará un código a su correo",
  check: "Verificar",
  checking: "Verificando...",
  reSendCode: "Reenviar código",
  validTimeCode: "Tiempo de vencimiento del código:",
  aboutUs: "¿Quienes somos?",
  register: "Registro",
  titleModalTerms: "Términos y condiciones",
  choosePhoto: "Escoge una foto",
  questionRegister: "¿Aún no eres parte del cambio?",
  putVerificationCode: "Ingresa el código de verificación",
  reSendCodeIn: "Reenviar en: ",
  reject: "Rechazar",
  searchPalcheholder: "Buscar en EcoIdeas",
  text: "Texto",
  video: "Video",
  image: "Imagen",
  petition: "Petición",
  complaint: "Queja",
  claim: "Reclamo",
  suggestion: "Sugerencia",
  deleteWareHouse: "Eliminar Almacén",
  deleteWinery: "Eliminar Bodéga ",
  deleteSubWinery: "Eliminar Sub-Bodega",
  update: "Actualizar",
  notifications: "Notificaciones",
  createConsignment: "Consignaciones",
  paymentNotifications: "Pagos",
  publications: "Publicaciones",
  addFriend: "Añadir amigo",
  unFollow: "dejar de seguir",
  follow: "Seguir",
  liveIn: "Vive en",
  albums: "Álbumes",
  saved: "Guardados",
  addToBag: "Agregar a la bolsa",
  editProfile: "Editar perfil",
  editYourProfile: "Edita tu perfil",
  save: "Guardar",
  verifyAccount: "Verificar cuenta",
  requestFranchisee: "Solicitud EcoTienda",
  requestReprsentative: "Solicitud EcoMaster",
  contentNotEnable: "Contenido no disponible",
  closeSession: "Cerrar sesión",
  createWinery: "Crear bodega",
  createSubWinery: "Crear subbodega",
  winery: "Bodega",
  wineries: "Bodegas",
  subWinery: "Sub Bodega",
  subWineries: "Sub Bodegas",
  whatWrite: "¿Qué quieres escribir?",
  createLive: "Live",
  warehouses: "EcoCeos",
  warehouse: "EcoCeo",
  updateWareHouseTitle: " EcoCeo",
  searchIn: "Buscar en ",
  
  tittleModalNewPost: 'Comparte lo que haces',
  gif: 'GIF',
  wareHouse: "Almacén",
  wareHouses: "Almacénes",
  whitOutPost: "Todavía no hay publicaciones",
  unFollow: "Dejar de seguir",
  save: 'Guardar',
  createSubWinery: "Crear sub-bodega",
  subWinery: "Sub-bodega",
  createLive: "Crea un en vivo",
  inventory: "Inventario",
  info: "Información",
  members: "Miembros",
  MarketPlace: "MarketPlace",
  chatRooms: "Salas de chat",
  chatRoom: "Sala de chat",
  reply: "Responder",
  kick: "Expulsar temporalmente",
  ban: "Expulsar",
  unSaved: "Eliminar",
  adminchatRoom: "Administrar Sala",
  zones: "Zonas",
  adminZone: "Administrar zona",
  campaigns: "Campañas",
  postCampaigns: "Gestionar Post de campaña",
  available: "disponible",
  createChatRoom: "Crear nueva sala",
  textWelcomeRooms: <>
    "COMPARTE TUS IDEAS CON EL RESTO DE LA COMUNIDAD <br /> Y AYÚDANOS A CUIDAR
    NUESTRO HOGAR"
  </>
  ,
  BestSeller: "Lo más vendido",
  Ecobolsa: "Ecobolsa",
  ecoPoints: "Ecopuntos",
  EcobolsaAdd: "Añadir a la Ecobolsa",
  representative: "EcoMaster",
  franchise: "EcoTienda",
  oilTitleHighlight: "Sistema ",
  oilTitle: "de recepción de aceite",
  oilRegisterTitle: " de aceite",
  getInto: "Ingresar",
  receivedOil: "Total de aceite recibido: ",
  oilMailForm: "Correo electrónico Usuario/Ecomaster",
  oilRegisterSubtitle1: "Recuerda que",
  oilRegisterSubtitle2: "mínimo",
  oilRegisterSubtitle3: "podrás recibir",
  liters: "L",
  oilRegisterSubtitle5: "de aceite, equivalente a",
  datePlaceholder: "DD/MM/AA",
  date: "Fecha",
  oilReceivedForm: "Registrar cantidad recibida en litros",
  quantity: "Cantidad",
  oilEcopointsSubtitle: "Cantidad de Ecopuntos:",
  oilRecordTitleHighlight: "Historial ",
  oilRecordTitle: "de recepciones",
  totalLitersReceived: "Total de litros recibidos: ",
  totalOfReceivedPoints: "Total de puntos recibidos:",
  inventoryTitleHighlight: "I",
  inventoryTitle: "nventario",
  inventories: "Inventarios",
  inventoryProducts: "Productos",
  inventoryPurchases: "Compras realizadas",
  historical: "Historico",
  ofSales: " de ventas",
  inventorySales: "Ventas realizadas",
  inventorySaleRegister: "Registrar venta",
  inventorySaleUtility: "Informe de utilidad",
  inventoryReportByType: "Productos mas/menos vendidos",
  user: "Usuario",
  stockAdmin: "Administrar almacenes",
  batches: "Lotes",
  productsCatalog: "Catálogo de productos",
  transfers: "Transferencias",
  returns: "Devoluciones",
  ownStock: "Almacén propio",
  consolidatedInventory: "Inventario consolidado",
  search: "Buscar",
  nameOrCode: "nombre o código",
  inventoryLocationsListTitleHighlight: 'Ubicaciones ',
  inventoryLocationsListTitle: 'de inventario',
  productLocationsListTitleHighlight: 'Productos ',
  productLocationsListTitle: 'de ',
  batchesLocationsListTitleHighlight: 'Lotes ',
  batchesLocationsListTitle: 'de ',
  myPurchases: 'Mis Compras',
  purchases: 'Compras',
  listTitle: 'Lista',
  saleRegisterTitle: ' venta de Ecotienda',
  details: 'Detalles ',
  ofOrder: 'de orden',
  saleRegisterTitle: ' venta'
  
};